// src/modules/marketplace/components/kraken/utils.ts

import { format } from "date-fns"
import { ru } from "date-fns/locale"
import { Kraken } from "../../interfaces"

/** Fixed colour per city so lines stay stable across renders. Falls back by index. */
export const CITY_COLORS = [
  "#1976d2",
  "#d32f2f",
  "#388e3c",
  "#f57c00",
  "#7b1fa2",
  "#0097a7",
  "#c2185b",
  "#5d4037",
] as const

export function cityColor(index: number): string {
  return CITY_COLORS[index % CITY_COLORS.length]
}

/** Format an ISO bucket start for the X axis, granularity depends on period. */
export function formatBucket(iso: string, period: Kraken.Period): string {
  const d = new Date(iso)
  if (isNaN(d.getTime())) return iso
  return period === "month"
    ? format(d, "LLL yy", { locale: ru })
    : format(d, "dd.MM", { locale: ru })
}

/** Russian number formatting; returns "—" for null/undefined. */
export function formatNumber(value: number | null | undefined): string {
  return value == null ? "—" : value.toLocaleString("ru-RU")
}

/** Russian price formatting; returns "—" for null (no sales in bucket). */
export function formatPrice(value: number | null | undefined): string {
  return value == null ? "—" : `${value.toLocaleString("ru-RU")} ₽`
}
